export default __webpack_public_path__ + "static/media/RS.70fdeb24.svg";